import React, { useEffect } from "react"

import { connect } from 'react-redux'
import { getPartyRecord, syncProfile } from '../actions/party'

import PartyComplete from '../components/PartyComplete'

export function PartyCertificate(props) {

    useEffect(() => {
        props.getPartyRecord(props.partyInfo.partyId)   
    }, [props.partyInfo.partyId])

    const handleSyncProfile = () => {
        props.syncProfile()
    }

    return (
        <div className="party-setting">
            <div className="party">
                <PartyComplete partyInfo={props.partyInfo} userRecord={props.userRecord} handleSyncProfile={handleSyncProfile} synchronizing={props.synchronizing} />
            </div>
        </div>
    )
}

const mapStateToProps = state => ({
    partyInfo: state.party.partyInfo,
    userRecord: state.party.userRecord,
    synchronizing: state.party.synchronizing,
});

const mapDispatchToProps = {
    getPartyRecord,
    syncProfile,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PartyCertificate)